import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import TextInput from "../../../sharedComponents/textInput/textInput";
import { Discount, Discounts } from "../../../../helpers/discount";
import { CapitalizationType } from "../../../../helpers/formatter";

interface DedicatedDiscountCodeProps {
  calculateStore?: CalculateStore;
}

export function DedicatedDiscountCode(props: DedicatedDiscountCodeProps) {
  const calculateStore = props.calculateStore!;
  const value: string = calculateStore.discounts.dedicatedDiscountCode.value ?? "";

  return (
    <div className="dedicated-discount-code">
      <div className="question-answer-container">
        <div className="question">{Discount.discountsConfiguration.dedicatedDiscountCode.label}</div>
        <TextInput
          value={value}
          capitalize={CapitalizationType.standard}
          onChange={(newVal) => {
            calculateStore.setDiscount(Discounts.dedicatedDiscountCode, newVal);
          }} />
      </div>
    </div>
  );
}

export default inject("calculateStore")(observer(DedicatedDiscountCode));
